import {
  Component,
  Input,
  EventEmitter,
  Output,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core"
import TitleBarNavigation from "src/app/cadastro/admin/models/titlebar/titlebar-navigation"
import { Router } from "@angular/router"
import { ModificationGuardService } from "src/app/cadastro/admin/services/modification-guard.service"

@Component({
  selector: "seb-titlebar",
  templateUrl: "./titlebar.component.html",
  styleUrls: ["./titlebar.component.css"],
})
export class TitlebarComponent implements AfterViewInit {
  @ViewChild("pageHeading") pageHeading: ElementRef<HTMLDivElement>

  @Input() hideBorderBottom: Boolean
  @Input() labelButton: String
  @Input() hideButtonTitlebar: Boolean
  @Input() integrationTooltipMessage: string
  @Input() pageHeadStyle = ""
  @Input() paths: TitleBarNavigation[]
  @Input() schoolHasExternalIntegrationId = false

  @Output() toCallModal: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    private router: Router,
    private modificationGuardService: ModificationGuardService
  ) {}

  ngAfterViewInit() {
    if (!this.pageHeading.nativeElement) return

    this.pageHeading.nativeElement.setAttribute("style", this.pageHeadStyle)
  }

  navigateToRoute(path: TitleBarNavigation) {
    if (path.routeNavigation) {
      const pathRoute =
        path.routeNavigation[0] === "/"
          ? path.routeNavigation
          : `/${path.routeNavigation}`

      if (path.modificationGuard) {
        this.modificationGuardService.isModifying = path.modificationGuard
      }

      this.router.navigate([pathRoute])
    }
  }

  onButtonClick() {
    this.toCallModal.emit()
  }

  activeClass(index: number, paths: string[]) {
    return index === paths.length - 1
  }

  hideLineBorderBottom() {
    return this.hideBorderBottom ? "hide-border-bottom" : ""
  }
}
